export type PixelValue = `${number}px`;

export const toPixelValue = (value: number): PixelValue => `${value}px`;
